import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { Chips } from './Chips';
import { whatIf } from '../data/salesCopy';
export function WhatIfSection() {
  return <section className="bg-brand-ivoryLight px-4 py-7 sm:py-9" data-id="element-277" data-mp="2e1yk25estauk">
      <div className="mx-auto max-w-3xl" data-id="element-278" data-mp="293n8nq8uusa8">
        <SectionTitle data-id="element-279" data-mp="294overz8h37s">{whatIf.heading}</SectionTitle>

        <ul className="mt-4 space-y-1.5" data-id="element-280" data-mp="295zwul57hyvq">
          {whatIf.nots.map(line => <li key={line} className="flex items-start gap-2 text-[13px] font-medium leading-snug text-brand-charcoal/85 sm:text-[15px]" data-id="element-281" data-mp="35w0k2fpxg7ax">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-clay" aria-hidden="true" data-id="element-282" data-mp="2x01ex0u1220a" />
              {line}
            </li>)}
        </ul>

        <p className="mt-4 text-center font-serif text-lg font-extrabold uppercase text-brand-sage sm:text-2xl" data-id="element-283" data-mp="3pjghkn5sde8n">
          {whatIf.need}
        </p>

        <div className="mt-3 flex justify-center" data-id="element-284" data-mp="34o9j67frocbk">
          <Chips items={whatIf.items} tone="sage" data-id="element-285" data-mp="34orr41bskezb" />
        </div>

        <p className="mt-4 border-t border-brand-sand/50 pt-3 text-center text-[13px] font-semibold leading-snug text-brand-charcoal sm:text-[15px]" data-id="element-286" data-mp="39nckbgsmlye9">
          {whatIf.close}
        </p>
      </div>
    </section>;
}